import { jsx as d } from "react/jsx-runtime";
import { $ as t } from "./utils-CTvPli9r.js";
import { forwardRef as o } from "react";
const s = o(({ className: a, ...e }, r) => /* @__PURE__ */ d(
  "div",
  {
    ref: r,
    className: t("rounded-xl border bg-card text-card-foreground shadow", a),
    ...e
  }
));
s.displayName = "Card";
const i = o(
  ({ className: a, ...e }, r) => /* @__PURE__ */ d("div", { ref: r, className: t("flex flex-col space-y-1.5 p-6", a), ...e })
);
i.displayName = "CardHeader";
const m = o(
  ({ className: a, ...e }, r) => /* @__PURE__ */ d("h3", { ref: r, className: t("font-semibold leading-none tracking-tight", a), ...e })
);
m.displayName = "CardTitle";
const l = o(
  ({ className: a, ...e }, r) => /* @__PURE__ */ d("p", { ref: r, className: t("text-sm text-muted-foreground", a), ...e })
);
l.displayName = "CardDescription";
const n = o(
  ({ className: a, ...e }, r) => /* @__PURE__ */ d("div", { ref: r, className: t("p-6 pt-0", a), ...e })
);
n.displayName = "CardContent";
const c = o(
  ({ className: a, ...e }, r) => /* @__PURE__ */ d("div", { ref: r, className: t("flex items-center p-6 pt-0", a), ...e })
);
c.displayName = "CardFooter";
export {
  s as Card,
  n as CardContent,
  l as CardDescription,
  c as CardFooter,
  i as CardHeader,
  m as CardTitle
};
//# sourceMappingURL=card.js.map
